import axios from 'axios';
import isObject from './isObject';
import setCookie from './setCookie';
import pickBy from 'lodash-es/pickBy';
import { trim, getVtxToken } from '@vtx/utils';

// 默认30秒超时
const SECOND = 30;
const MILL_SECOND = 1000;

let t;

/**
 * 基于 axios 封装的请求封装
 * axios文档 http://www.axios-js.com/zh-cn/docs/
 * 支持 Get 和 Post 请求
 */
class Http {
    constructor(options) {
        // 创建axios实例
        this.instance = this._createAxios(options);
        t = this;
    }
    // 初始化
    _createAxios(options) {
        let { token, tenantId, userId } = getVtxToken() || {};

        // 创建实例
        let instance = axios.create({
            // `timeout` 指定请求超时的毫秒数(0 表示无超时时间)
            // 如果请求话费了超过 `timeout` 的时间，请求将被中断
            timeout: MILL_SECOND * SECOND,
            headers: {
                Authorization: token ? `Bearer ${token}` : '',
                'Cache-Control': 'no-cache',
                'content-type': 'application/json;charset=UTF-8',
                tenantId,
                userId,
            },
            ...options,
        });
        instance.interceptors.response.use(this._responseHandler, this._errorHandler);
        return instance;
    }

    /**
     * get 请求
     * @param {*} url
     * @param {*} options {body}
     */
    get(url, options = {}) {
        const { body = {}, headers } = options;
        // 过滤掉值为 '' || undefined || null 的对象属性
        const postData = isObject(body)
            ? pickBy(trim(body), function (value) {
                return value !== '' && value !== undefined && value !== null;
            })
            : {};
        return t.instance.get(url, {
            headers: { ...headers },
            params: {
                ...postData,
            },
        });
    }

    /**
     * post 请求
     * @param {*} url
     * @param {*} options
     */
    post(url, options = {}) {
        const { body = {}, headers = {} } = options;

        return t.instance.post(url, body, {
            headers: headers ? headers : {},
        });
    }

    /**
     * 响应数据的处理
     * @param {*} response
     */
    _responseHandler(response) {
        const { status, data, statusText } = response;

        let tokenInfo = response.headers['ACCESS-TOKEN'] || response.headers['access-token'];
        if (tokenInfo) {
            tokenInfo = JSON.parse(tokenInfo);
            let token = tokenInfo.access_token;
            setCookie('token', token);
            localStorage.setItem('token', token);
        }
        if (status >= 200 && status < 300) {
            // 判断条件更据后期实际情况调整
            if (!data.result) {
                return data;
            } else {
                console.log(data.msg || '请求信息错误');
                return;
            }
        }
        const error = new Error(statusText);
        error.response = response;
        throw error;
    }

    /**
     * 请求错误处理
     * @param {*} error
     */
    _errorHandler(error) {
        if (error.response) {
            let msg;
            switch (error.response.status) {
                case 404:
                    msg = '接口请求不存在！错误码【404】。';
                    break;
                case 500:
                    msg = '服务端应用接口异常！错误码【500】。';
                    break;
                case 401:
                    if (process.env.MENU) {
                        if (window.location.hash.indexOf('login') !== -1) {
                            msg = '请求错误，请检查或刷新重试！';
                        } else {
                            // history.push('/login');
                        }
                    } else {
                        localStorage.setItem('isLogin', 'no');
                        msg = '登录过期，请退出重新登录！';
                    }
                    break;
                default:
                    msg = '请求错误，请检查或刷新重试！';
                    break;
            }
            console.log(msg);
        } else {
            console.log('服务不可用');
        }
    }

    // 获取实例
    getInstance() {
        return t.instance;
    }
}

const http = new Http();
export default http;
